module.exports = __webpack_public_path__ + "img/btn_start.7b886690.svg";